import { Component } from 'react';
import { createPortal } from 'react-dom';
import { Form, Select, Input, Icon, Button } from 'semantic-ui-react';
import { isMobile, isTablet } from 'react-device-detect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/pro-solid-svg-icons';
import i18n from '../../locales/i18n';

class CustomDropdown extends Component {
    state = {
        mobileOpen: false,
        closing: false, // pour gérer animation fermeture
        searchQuery: '',
        tempValue: null, // utilisé uniquement pour mode multiple
    };

    render() {
        const { forceOpen } = this.props;
        const sortedOptions = this.getSortedOptions();

        return (
            <>
                <Form.Field
                    control={Select}
                    className={isMobile || isTablet ? 'mobile-select custom-dropdown' : 'custom-dropdown'}
                    onSearchChange={this.handleSearchChange}
                    onClick={(e) => {
                        if (this.props.onOpen) this.props.onOpen(e);
                        this.handleMobileTrigger(e);
                    }}
                    {...this.props}
                    options={sortedOptions}
                    scrolling
                    search={!isMobile && !isTablet ? this.props.search : undefined}
                    open={isMobile || isTablet ? false : undefined}
                    onChange={this.handleChange}
                    style={{ margin: 0, ...(this.props.style || {}) }}
                />
                {(this.state.mobileOpen || forceOpen) && this.renderMobileMenu()}
            </>
        );
    }

    renderMobileMenu() {
        const { placeholder, value, multiple, selectAll, noResultsMessage, onSearchChange, loading } = this.props;
        const { tempValue } = this.state;
        const filteredOptions = this.getFilteredOptions();
        const animationClass = this.state.closing ? 'closing' : 'opening';

        const portalRoot = document.body;
        if (!portalRoot) return null;

        return createPortal(
            <div className={`mobile-select-overlay ${animationClass}`}>
                <div className="mobile-select-header">
                    <span>{placeholder}</span>
                    <Button icon='close' color='blue' size='small' style={{ marginRight: 0 }} onClick={this.handleMobileClose} />
                </div>
                <div className="mobile-select-search">
                    {!onSearchChange ?
                        <Input
                            fluid
                            placeholder={i18n.t("Rechercher...")} title={i18n.t("Rechercher...")}
                            icon='search' iconPosition='left'
                            value={this.state.searchQuery}
                            onChange={this.handleSearchChange}
                        />
                        : <Input
                            fluid
                            placeholder={i18n.t("Rechercher...")} title={i18n.t("Rechercher...")}
                            icon='search' iconPosition='left'
                            value={this.state.searchQuery}
                            onChange={(_, data) => {
                                this.setState({ searchQuery: data.value });
                                onSearchChange(_, { searchQuery: data.value });
                            }}
                        />}
                </div>
                {selectAll && multiple &&
                    <Button
                        color={'blue'} content={i18n.t("Tout sélectionner")}
                        onClick={(e) => {
                            this.handleChange(e, { name: this.props.name, type: this.props.type, value: [...(value || []), 'select-all'] });
                            this.handleMobileClose();
                        }} style={{ padding: '3px 8px', marginLeft: 'auto', marginTop: '5px' }}
                    />}
                <div className={`mobile-select-options ${multiple ? 'multiple' : ''}`}>
                    {!loading ?
                        <>
                            {filteredOptions.map((option) => {
                                const isSelected = multiple
                                    ? Array.isArray(tempValue) && tempValue.includes(option.value)
                                    : value === option.value;

                                return (
                                    <div
                                        key={option.value} ref={isSelected && !this.selectedOptionRef ? (el) => this.selectedOptionRef = el : null}
                                        className={`mobile-select-option ${isSelected ? 'selected' : ''}`}
                                        onClick={() => this.handleMobileSelect(option.value)}
                                    >
                                        <div className="mobile-option-content">
                                            <div className="top-line">
                                                {option.flag && (
                                                    <i className={`flag ${option.flag}`} style={{ marginRight: '0.5em' }} />
                                                )}
                                                <div className="main-text">{this.renderText(option)}</div>
                                                {option.description && (
                                                    <div className="option-description">{option.description}</div>
                                                )}
                                            </div>
                                            {option.title && <div className="option-title">{option.title}</div>}
                                        </div>
                                    </div>
                                );
                            })}
                            {filteredOptions.length === 0 && (
                                <div className="mobile-select-no-results">
                                    {noResultsMessage || 'Aucun résultat trouvé'}
                                </div>
                            )}
                        </>
                        :
                        <div className="mobile-select-loading">
                            <Icon name="spinner" loading size='large' />
                            <h5>{noResultsMessage}</h5>
                        </div>}
                </div>
                {multiple &&
                    <div className="mobile-select-footer">
                        <Button.Group widths={4}>
                            <Button type='button' color='red' disabled={!this.hasChanges()} onClick={this.handleMobileClose}>
                                <FontAwesomeIcon icon={faTimes} style={{ marginRight: '10px' }} />
                            </Button>
                            <Button type='button' color='green' disabled={!this.hasChanges()} onClick={this.handleValidate}>
                                <FontAwesomeIcon icon={faCheck} style={{ marginRight: '10px' }} />
                            </Button>
                        </Button.Group>
                    </div>}
            </div>,
            portalRoot
        );
    }

    componentDidMount() {
        if (isMobile || isTablet) this.selectedOptionRef = null;
    }

    componentDidUpdate(_, prevState) {
        if (!prevState.mobileOpen && this.state.mobileOpen && this.props.value)
            if (this.selectedOptionRef?.scrollIntoView)
                this.selectedOptionRef.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    handleChange = (e, data) => {
        const { multiple, selectAll } = this.props;
        if (multiple && selectAll && Array.isArray(data.value) && data.value.includes('select-all')) {
            const options = this.getFilteredOptions();
            options.forEach(option => {
                if (!data.value.includes(option.value))
                    data.value.push(option.value);
            });
            data.value = data.value.filter(v => v !== 'select-all');
        }
        this.props.onChange(e, data);
    }

    handleMobileTrigger = (e) => {
        const { value, multiple } = this.props;

            console.log('open');

        if (isMobile || isTablet) {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }

            if (document.activeElement && typeof document.activeElement.blur === 'function')
                document.activeElement.blur();

            setTimeout(() => {
                this.setState({
                    mobileOpen: true,
                    searchQuery: '',
                    tempValue: multiple ? [...(Array.isArray(value) ? value : [])] : null,
                });
            }, 100);
        }
    };

    handleMobileClose = () => {
        // Lance l’animation de fermeture
        this.setState({ closing: true }, () => {
            // Après la durée de l’animation, on ferme vraiment le menu
            setTimeout(() => {
                this.setState({ mobileOpen: false, closing: false }, () => {
                    if (this.props.onClose) this.props.onClose();
                });
            }, 300); // durée de l’animation CSS
        });
    };

    handleMobileSelect = (value) => {
        const { multiple } = this.props;
        if (multiple) {
            this.setState((prevState) => {
                const current = Array.isArray(prevState.tempValue) ? prevState.tempValue : [];
                const alreadySelected = current.includes(value);
                const updated = alreadySelected
                    ? current.filter((v) => v !== value)
                    : [...current, value];

                return { tempValue: updated };
            });
        } else {
            const { onChange } = this.props;
            if (onChange) onChange(null, { name: this.props.name, value });
            this.handleMobileClose();
        }
    };

    handleSearchChange = (e) => this.setState({ searchQuery: e.target.value });
    handleValidate = () => {
        const { name, onChange } = this.props;
        const { tempValue } = this.state;
        if (onChange) onChange(null, { name, value: tempValue });
        this.handleMobileClose();
    };

    getText = (option) => {
        if (!option) return '';
        if (option.rawText) return option.rawText;
        if (['string', 'number'].includes(typeof option.text)) return option.text;
        if (option.content) return option.content;
        if (typeof option.children === 'string') return option.children;
        return '';
    };

    renderText = (option) => {
        if (!option) return '';
        if (option.text) return option.text;
        if (option.rawText) return option.rawText;
        if (typeof option.text === 'number') return option.text;
        if (option.content) return option.content;
        if (typeof option.children === 'string') return option.children;
        return '';
    };

    getSortedOptions = () => {
        const { options = [], customSort, multiple, selectAll } = this.props;
        const addSelectAll = multiple && selectAll && !isMobile && !isTablet && !options.find(option => option.value === 'select-all');
        if (customSort || customSort === undefined) {
            if (addSelectAll) return [{ text: `${i18n.t("Sélectionner tout")}...`, value: 'select-all' }, ...options];
            return options;
        }

        const sortedOptions = [...options].sort((a, b) => {
            const textA = (a.rawText ?? this.getText(a)).toString().toLowerCase();
            const textB = (b.rawText ?? this.getText(b)).toString().toLowerCase();

            // Tri numérique si possible
            const numA = parseFloat(textA);
            const numB = parseFloat(textB);
            if (!isNaN(numA) && !isNaN(numB)) return numA - numB;
            return textA.localeCompare(textB);
        });

        if (addSelectAll) return [{ text: `${i18n.t("Sélectionner tout")}...`, value: 'select-all' }, ...sortedOptions];
        return sortedOptions;
    };

    getFilteredOptions = () => {
        const sortedOptions = this.getSortedOptions();
        if (this.props.onSearchChange) return sortedOptions;

        const { searchQuery } = this.state;
        return this.props.search
            ? this.props.search(sortedOptions, searchQuery)
            : sortedOptions.filter((opt) => {
                const text = this.getText(opt);
                return text.toString().toLowerCase().includes(searchQuery.toLowerCase());
            });
    };

    hasChanges = () => {
        const { multiple, value } = this.props;
        const { tempValue } = this.state;

        if (!multiple) return false;

        const current = Array.isArray(value) ? value.slice().sort() : [];
        const temp = Array.isArray(tempValue) ? tempValue.slice().sort() : [];

        return current.length !== temp.length || current.some((v, i) => v !== temp[i]);
    };
}

export default CustomDropdown;